export const ODDS_SCREEN_LEAGUE_IDS = Object.freeze([
  "nfl", "cfb", "nba", "wnba", "ncaab", "mlb", "nhl", "soccer", "tennis", "mma", "golf",
  "lol", "csgo", "dota2", "valorant", "cod", "r6",
]);
